
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/danh-muc-san-pham/[slug]",
      function () {
        return require("private-next-pages/danh-muc-san-pham/[slug].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/danh-muc-san-pham/[slug]"])
      });
    }
  